export default "__VITE_ASSET__3b2ff5a9__"